import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

import type { OrganizationId } from '@beaded/models'

import { ErrorCard } from 'components/ErrorCard'

import { orgQueries, projectQueries } from 'lib/queries'

export const Route = createFileRoute('/_auth/orgs/$id')({
  component: () => <Outlet />,
  notFoundComponent: () => <ErrorCard errors={['Organization not found']} />,
  loader: async ({ context: { queryClient }, params: { id } }) => {
    const orgId = Number(id) as OrganizationId
    if (Number.isNaN(orgId)) throw notFound()

    void queryClient.prefetchQuery(projectQueries.byOrg(orgId))

    let data: { org?: unknown } | undefined
    try {
      data = await queryClient.ensureQueryData(orgQueries.detail(orgId))
    } catch {
      // Fetch errors (e.g. 403 "access denied") stay in the query cache;
      // the Org page surfaces them via ErrorCard.
      return
    }

    // The API returns 200 with no org for global-view users when the org
    // does not exist -- render a 404 instead of a blank page (#2490).
    if (!data?.org) throw notFound()
  },
})
